/* Kōzu — comportements dynamiques : compteurs, survol lumineux, vidéos, barre mobile, fenêtre audit */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. Compteurs animés [data-ag-count]
  const counters = (root) => root.querySelectorAll('[data-ag-count]:not([data-done])').forEach(el => {
    const target = parseFloat(el.dataset.agCount) || 0; el.dataset.done = '1';
    if (reduce || !('IntersectionObserver' in window)) { el.textContent = target; return; }
    el.textContent = '0';
    const io = new IntersectionObserver(([e]) => { if (!e.isIntersecting) return; io.disconnect();
      const t0 = performance.now(), dur = 1400;
      const step = (now) => { const k = Math.min(1, (now - t0) / dur), ease = 1 - Math.pow(1 - k, 4);
        el.textContent = Math.round(target * ease); if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step); }, { threshold: .5 });
    io.observe(el);
  });

  // 2. Survol lumineux .ag-spot
  const spots = (root) => { if (!matchMedia('(hover:hover)').matches) return;
    root.querySelectorAll('.ag-spot:not([data-spot])').forEach(el => { el.dataset.spot = '1';
      el.addEventListener('pointermove', e => { const r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (e.clientX - r.left) + 'px'); el.style.setProperty('--my', (e.clientY - r.top) + 'px'); }); }); };

  // 3. Vidéos verticales : lecture quand visibles, son au toucher, points d'indication
  const reels = (root) => root.querySelectorAll('[data-ag-reels]:not([data-ready])').forEach(track => {
    track.dataset.ready = '1';
    const cards = [...track.querySelectorAll('.ag-reel')];
    const dots = track.parentElement.querySelector('[data-ag-dots]');
    if (dots) { dots.innerHTML = cards.map(() => '<span></span>').join(''); }
    const io = new IntersectionObserver(es => es.forEach(e => { const v = e.target.querySelector('video'); if (!v) return;
      if (e.isIntersecting && !reduce) { v.preload = 'auto'; v.play().catch(() => {}); } else v.pause(); }), { threshold: .6 });
    cards.forEach(c => io.observe(c));
    track.addEventListener('click', e => { const b = e.target.closest('[data-ag-sound]'); if (!b) return;
      const card = b.closest('.ag-reel'), v = card.querySelector('video'); if (!v) return;
      cards.forEach(c => { if (c !== card) { const o = c.querySelector('video'); if (o) o.muted = true; c.classList.remove('is-sound'); } });
      v.muted = !v.muted; card.classList.toggle('is-sound', !v.muted); b.setAttribute('aria-label', v.muted ? 'Activer le son' : 'Couper le son'); if (v.paused) v.play().catch(() => {}); });
    const upd = () => { if (!dots) return; const i = Math.round(track.scrollLeft / ((cards[0]?.offsetWidth || 1) + 16));
      [...dots.children].forEach((d, k) => d.classList.toggle('is-on', k === Math.min(i, cards.length - 1))); };
    track.addEventListener('scroll', upd, { passive: true }); upd();
  });

  // 4. Barre d'action mobile : visible après le héros, cachée sur le formulaire de contact
  const sticky = () => { const bar = document.querySelector('[data-ag-sticky]'); if (!bar || bar.dataset.ready) return; bar.dataset.ready = '1';
    const hero = document.querySelector('.ag-hero'), contact = document.querySelector('#contact');
    let pastHero = !hero, onContact = false;
    const set = () => { const on = pastHero && !onContact; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on));
      bar.querySelector('a')?.setAttribute('tabindex', on ? '0' : '-1'); };
    if (hero) new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; set(); }, { threshold: .1 }).observe(hero);
    if (contact) new IntersectionObserver(([e]) => { onContact = e.isIntersecting; set(); }, { threshold: .15 }).observe(contact);
    if (!hero) setTimeout(() => { pastHero = scrollY > 400; set(); addEventListener('scroll', () => { pastHero = scrollY > 400; set(); }, { passive: true }); }, 0);
  };

  // 5. Fenêtre audit : tout lien finissant par #audit
  const modal = () => { const d = document.querySelector('[data-ag-modal]'); if (!d || d.dataset.ready) return; d.dataset.ready = '1';
    document.addEventListener('click', e => { const a = e.target.closest('a[href$="#audit"]'); if (!a) return; e.preventDefault();
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', ''); d.querySelector('input:not([type=hidden])')?.focus(); });
    d.querySelector('[data-ag-modal-close]')?.addEventListener('click', () => d.close());
    d.addEventListener('click', e => { if (e.target === d) d.close(); });
    if (location.hash === '#audit' || d.querySelector('.ag-form__ok, .ag-form__err')) { try { d.showModal(); } catch (_) {} }
  };

  const init = (root = document) => { counters(root); spots(root); reels(root); sticky(); modal(); };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

/* v3 — mot rotatif [data-ag-rotate] */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (root = document) => root.querySelectorAll('[data-ag-rotate]:not([data-ready])').forEach(r => {
    r.dataset.ready = '1'; const words = [...r.querySelectorAll('.ag-rotator__word')]; if (words.length < 2 || reduce) return;
    let i = 0; const ms = (parseInt(r.dataset.agRotate, 10) || 26) * 100;
    setInterval(() => { if (document.hidden) return;
      const cur = words[i]; i = (i + 1) % words.length; const nxt = words[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out'); cur.setAttribute('aria-hidden', 'true');
      nxt.classList.remove('is-out'); nxt.classList.add('is-on'); nxt.removeAttribute('aria-hidden');
      setTimeout(() => cur.classList.remove('is-out'), 650);
    }, ms);
  });
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

/* v3 — Dock « Commencer » */
(() => {
  const init = () => { const d = document.querySelector('[data-ag-dock]'); if (!d || d.dataset.ready) return; d.dataset.ready = '1';
    const btn = d.querySelector('[data-ag-dock-open]'), panel = d.querySelector('[data-ag-dock-panel]');
    const set = (open) => { d.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) setTimeout(() => panel.querySelector('input:not([type=hidden]), button')?.focus({ preventScroll: true }), 300); else btn.focus({ preventScroll: true }); };
    btn.addEventListener('click', () => set(true));
    d.querySelectorAll('[data-ag-dock-close]').forEach(el => el.addEventListener('click', () => set(false)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && d.classList.contains('is-open')) set(false); });
    document.addEventListener('click', e => { const a = e.target.closest('a[href$="#commencer"]'); if (!a) return; e.preventDefault(); set(true); });
    if (location.hash === '#commencer' || panel.querySelector('.ag-dock__ok, .errors')) set(true);
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
